export { default as SectorRotationCard } from './component';
